export interface Video {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  publishDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const videos: Video[] = [
  {
    id: 1,
    title: '春风十里不如你',
    category: 'yingshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20romantic%20drama%20scene%20with%20young%20couple%20in%20urban%20setting%2C%20warm%20cinematic%20lighting%2C%20soft%20color%20palette%20with%20peach%20and%20cream%20tones%2C%20emotional%20atmosphere%2C%20film%20poster%20style%2C%20clean%20composition&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '45:32',
    views: 1280000,
    rating: 9.2,
    description: '一部关于青春与成长的都市情感剧，讲述了年轻人在大城市追求梦想的故事，豆瓣高分推荐。',
    tags: ['都市情感', '青春', '高分剧集'],
    publishDate: '2026-07-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '舌尖上的家乡·川味篇',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sichuan%20cuisine%20documentary%20scene%20with%20colorful%20spicy%20dishes%20on%20wooden%20table%2C%20steaming%20hot%20pot%2C%20warm%20kitchen%20lighting%2C%20red%20and%20gold%20color%20scheme%2C%20gourmet%20food%20photography%2C%20rich%20textures%2C%20appetizing%20presentation&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '52:18',
    views: 2560000,
    rating: 9.6,
    description: '深入四川各地，探寻最地道的川菜文化，从街头小吃到宴席大菜，记录美食背后的故事。',
    tags: ['美食', '川菜', '人文纪实'],
    publishDate: '2026-07-20',
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '爆笑办公室第三季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20office%20comedy%20variety%20show%20poster%20with%20group%20of%20colleagues%20laughing%20together%2C%20bright%20colorful%20office%20setting%2C%20playful%20atmosphere%2C%20clean%20modern%20design%2C%20cheerful%20vibrant%20colors%20with%20yellow%20and%20orange%20accents&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '68:45',
    views: 3450000,
    rating: 8.9,
    description: '人气爆棚的职场喜剧综艺，每期邀请不同嘉宾分享职场趣事，笑声不断，治愈解压首选。',
    tags: ['喜剧', '职场', '综艺'],
    publishDate: '2026-08-01',
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '星空下的守候',
    category: 'yingshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20under%20starry%20night%20sky%2C%20couple%20silhouette%20against%20galaxy%20background%2C%20dreamy%20purple%20and%20blue%20color%20palette%2C%20cinematic%20film%20poster%2C%20emotional%20and%20poetic%20atmosphere%2C%20soft%20gradient%20lighting&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '42:10',
    views: 890000,
    rating: 8.7,
    description: '治愈系都市爱情剧，两个孤独灵魂在星空下相遇相知，温暖人心的故事。',
    tags: ['爱情', '治愈', '都市'],
    publishDate: '2026-07-28',
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '创意短视频合集·搞笑篇',
    category: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20short%20video%20collage%20with%20funny%20moments%2C%20colorful%20pop%20art%20style%2C%20multiple%20small%20squares%20showing%20different%20comedy%20scenes%2C%20vibrant%20and%20energetic%2C%20social%20media%20aesthetic%2C%20youth%20culture%20vibe&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '15:20',
    views: 5670000,
    rating: 9.0,
    description: '精选全网最搞笑短视频合集，让你一次笑个够，减压放松必备。',
    tags: ['搞笑', '短视频', '合集'],
    publishDate: '2026-08-05',
    isHot: true,
    isNew: true,
  },
  {
    id: 6,
    title: '大秦帝国之崛起',
    category: 'yingshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20poster%20with%20ancient%20warriors%20and%20palace%20architecture%2C%20dramatic%20golden%20and%20bronze%20color%20scheme%2C%20grand%20scale%20battle%20scene%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20lighting&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '50:00',
    views: 4120000,
    rating: 9.4,
    description: '史诗级历史巨制，全景展现大秦帝国统一六国的壮阔历程，制作精良，演员阵容强大。',
    tags: ['历史', '史诗', '正剧'],
    publishDate: '2026-06-10',
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: '荒野求生·中国篇',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Wilderness%20survival%20documentary%20scene%20in%20Chinese%20mountains%2C%20adventurer%20navigating%20dense%20forest%2C%20natural%20green%20tones%2C%20dramatic%20landscape%20photography%2C%20misty%20mountain%20peaks%2C%20adventure%20spirit%2C%20cinematic%20wide%20shot&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '55:40',
    views: 1890000,
    rating: 9.1,
    description: '跟随探险家深入中国最险峻的荒野地带，展现极限生存的勇气与智慧。',
    tags: ['探险', '野外', '极限'],
    publishDate: '2026-07-12',
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: '舞林争霸2026',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dance%20competition%20show%20stage%20with%20dynamic%20spotlights%2C%20dancer%20in%20mid-motion%2C%20vibrant%20red%20and%20gold%20stage%20lighting%2C%20energetic%20performance%20atmosphere%2C%20modern%20stage%20design%2C%20exciting%20competition%20vibe&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '90:00',
    views: 2340000,
    rating: 8.5,
    description: '全国顶级舞者齐聚一堂，各展绝技，争夺年度舞王称号，视觉盛宴不容错过。',
    tags: ['舞蹈', '竞技', '综艺'],
    publishDate: '2026-08-02',
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '最美中国·云南篇',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Yunnan%20China%20with%20terraced%20rice%20fields%2C%20ancient%20town%2C%20snow%20mountain%20background%2C%20golden%20sunset%20lighting%2C%20breathtaking%20natural%20scenery%2C%20travel%20documentary%20style%2C%20vibrant%20green%20and%20gold%20colors&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '48:30',
    views: 3100000,
    rating: 9.5,
    description: '航拍镜头下的云南绝美风光，从雪山到热带雨林，展现多彩云南的自然与人文。',
    tags: ['风光', '云南', '航拍'],
    publishDate: '2026-07-05',
    isHot: true,
    isNew: false,
  },
  {
    id: 10,
    title: '编程入门·零基础学Python',
    category: 'jiaoyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20coding%20education%20scene%20with%20laptop%20showing%20Python%20code%2C%20clean%20minimalist%20desk%20setup%2C%20warm%20lamp%20lighting%2C%20coding%20tutorial%20aesthetic%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20tech%20education%20vibe&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '35:15',
    views: 1560000,
    rating: 9.3,
    description: '从小白到大神，零基础Python编程教程，通俗易懂，实战案例丰富。',
    tags: ['编程', 'Python', '教程'],
    publishDate: '2026-06-25',
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '治愈系日常vlog合集',
    category: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20daily%20life%20vlog%20aesthetic%20with%20warm%20apartment%20interior%2C%20cat%20on%20windowsill%2C%20coffee%20cup%2C%20soft%20morning%20light%2C%20minimalist%20lifestyle%2C%20comforting%20and%20peaceful%20atmosphere%2C%20cream%20and%20beige%20tones&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '12:50',
    views: 2890000,
    rating: 9.0,
    description: '温暖的日常记录，慢生活美学，让人在忙碌中找到片刻宁静。',
    tags: ['vlog', '治愈', '生活'],
    publishDate: '2026-08-04',
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '国风动漫·山海经异兽录',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animation%20poster%20with%20fantastical%20creatures%20from%20Shan%20Hai%20Jing%2C%20traditional%20ink%20painting%20style%20blended%20with%20modern%20animation%2C%20mystical%20atmosphere%2C%20gold%20and%20jade%20color%20palette%2C%20epic%20fantasy%20vibe&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '28:30',
    views: 1980000,
    rating: 9.2,
    description: '基于《山海经》改编的国风奇幻动漫，精美画风演绎上古神话世界。',
    tags: ['国风', '动漫', '神话'],
    publishDate: '2026-07-22',
    isHot: true,
    isNew: false,
  },
  {
    id: 13,
    title: '吉他入门教程·从零开始',
    category: 'jiaoyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20tutorial%20scene%20with%20hands%20on%20guitar%20strings%2C%20warm%20wooden%20interior%2C%20music%20notation%20visible%2C%20cozy%20learning%20atmosphere%2C%20soft%20natural%20light%2C%20brown%20and%20cream%20tones&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '42:00',
    views: 890000,
    rating: 8.8,
    description: '系统学吉他，零基础也能轻松上手，从持琴姿势到弹唱一首完整的歌。',
    tags: ['吉他', '音乐', '教程'],
    publishDate: '2026-07-18',
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: 'CBA精彩集锦·季后赛',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20basketball%20league%20playoff%20intense%20game%20moment%2C%20player%20dunking%20with%20dramatic%20stadium%20lighting%2C%20crowd%20cheering%2C%20fast%20action%20shot%2C%20red%20and%20white%20team%20colors%2C%20sports%20photography%20style&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '18:45',
    views: 3450000,
    rating: 9.1,
    description: 'CBA季后赛精彩瞬间全收录，扣篮、绝杀、逆转，热血篮球不容错过。',
    tags: ['篮球', 'CBA', '集锦'],
    publishDate: '2026-08-03',
    isHot: true,
    isNew: true,
  },
  {
    id: 15,
    title: '华语金曲MV精选',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20pop%20music%20MV%20collection%20aesthetic%2C%20vibrant%20concert%20stage%20with%20colorful%20lights%2C%20microphone%20in%20spotlight%2C%20musical%20notes%20floating%2C%20warm%20golden%20and%20pink%20lighting%2C%20emotional%20music%20atmosphere&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '22:10',
    views: 1780000,
    rating: 9.0,
    description: '精选华语乐坛经典与流行MV，从怀旧金曲到最新热门，一次听过瘾。',
    tags: ['音乐', 'MV', '华语'],
    publishDate: '2026-07-30',
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    title: '斗罗大陆·双神之战',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20battle%20scene%20with%20fantasy%20warriors%20in%20epic%20confrontation%2C%20glowing%20energy%20effects%2C%20ancient%20Chinese%20fantasy%20setting%2C%20dynamic%20action%20pose%2C%20golden%20and%20azure%20color%20contrast%2C%20game-like%20visual&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    duration: '32:00',
    views: 5670000,
    rating: 9.3,
    description: '国民级动漫最新篇章，双神之战震撼来袭，视觉特效全面升级。',
    tags: ['动漫', '玄幻', '热血'],
    publishDate: '2026-08-06',
    isHot: true,
    isNew: true,
  },
];